import * as e from "react";
const h = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GI_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#GI_svg__a)" }, /* @__PURE__ */ e.createElement("path", { fill: "#F7FCFF", d: "M0 0h32v24H0z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 16h32v8H0v-8z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.389 5H13.61v4.616h-.945v-2.77H8.89v2.77H7v.923h.945v4.614h15.111V10.54H24v-.923h-1.888v-2.77h-3.778v2.77h-.945V5zM24 15.154H7v.923h17v-.923z",
      fill: "#DB000B"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.834 8.589a.82.82 0 011.64 0v1.21h-1.64V8.59zM19.277 8.589a.82.82 0 011.64 0v1.21h-1.64V8.59z",
      fill: "#272727"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.568 13.47a1.086 1.086 0 112.173 0v1.869H9.568V13.47z",
      fill: "#272727"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.012 13.47a1.086 1.086 0 112.172 0v1.869h-2.172V13.47z",
      fill: "#272727"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.895 13.639a1.392 1.392 0 012.783 0v2.67h-2.784v-2.67z",
      fill: "#272727"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.555 7.666a.82.82 0 011.64 0V9.8h-1.64V7.666z",
      fill: "#272727"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#DE1A23", d: "M7 8.692h.944v.923H7z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.5 6h1v1h-1V6zm3.818 0h1v1h-1V6zm-.568 0h-1.5v1h1.5V6zM18.09 6h1v1h-1V6zm3.726 0h1v1h-1V6zm-.613 0h-1.5v1h1.5V6zM13.799 4.022h-1v1h1v-1zm1.5 0h-1v1h1v-1zm.5 0h1v1h-1v-1zm2.5 0h-1v1h1v-1z",
      fill: "#DE1A23"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#DE1A23", d: "M23 8.774h1v.839h-1z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.44 18.453l2.712-1.774-2.894-1.354-2.895 1.664 3.076 1.464zm-1.06-1.612l.888-.595.938.51-.843.552-.982-.467zM13.475 21.006h1.473v1.107-.374h-.915v.374h-.558v-1.107z",
      fill: "#E8AA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.815 18.113h1.25v4h-1.25v-4z",
      fill: "#E8AA00"
    }
  ))
);
export {
  h as default
};
